import React from 'react'

import Close from '../../assets/close.svg'
import './styles.css'

import cfLogo from '../../assets/cf_logo.png'

const modalHeader = ({ handleClose, view }) => {
  return (
    <div className="ct-modal-header">
      <div>
        <div><img src={cfLogo} alt="Logo" /></div>
        <span className="ct-text__heading">{view?.screen === 'order' ? "Update your Candlefish workshop" : "Schedule a workshop with Candlefish"}</span>
      </div>
      <div>
        <button className="ct-modal-header__close" onClick={handleClose}>
          <img src={Close} alt="Close" />
        </button>
      </div>
    </div>
  )
}

export default modalHeader
